import { Accordion } from './accordion';
import { AccordionTabs } from './accordion-tabs';
import { TabPanel } from './tab-panel';

export {
    Accordion,
    AccordionTabs,
    TabPanel,
};
